import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { normalizePath } from '../legal/routes';

/**
 * Sends `/?lang=de` and return visitors who chose German on to `/de`.
 * Crawlers have no saved preference, so `/` stays the English document.
 */
const SavedLanguageRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = normalizePath(location.pathname);
    const lang = new URLSearchParams(location.search).get('lang');

    if (path === '/' && lang === 'de') {
      navigate({ pathname: '/de', hash: location.hash }, { replace: true });
      return;
    }

    if (path === '/de' && lang === 'en') {
      navigate({ pathname: '/', hash: location.hash }, { replace: true });
      return;
    }

    if (path === '/' && !lang) {
      try {
        if (localStorage.getItem('tamerintech-language') === 'de') {
          navigate({ pathname: '/de', hash: location.hash }, { replace: true });
        }
      } catch {
        // Storage can be blocked. The URL still decides the language.
      }
    }
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
};

export default SavedLanguageRedirect;
